import request from '@/utils/request';
/* 列表 */
export function orderList (data) {
  return request({
    url: '/refund/queryWebRefundPageList',
    method: 'POST',
    data
  });
}
/* 订单信息表明细 */
export function fetchWebRefundDetailById(data) {
  return request({
    url: '/refund/fetchWebRefundDetailById',
    method: 'POST',
    data
  });
}
/* 审核退款 */
export function auditRefund(data) {
  return request({
    url: '/refund/auditRefund',
    method: 'POST',
    data
  });
}
/* 退货退款第一次审核 */
export function auditRefundStatus(data) {
  return request({
    url: '/refund/auditRefundStatus',
    method: 'POST',
    data
  });
}
/* 退款记录物流信息 */
export function fetchRefundLogisticsById(data) {
  return request({
    url: '/refund/fetchRefundLogisticsById',
    method: 'POST',
    data
  });
}
// 订单导出Excel
export function orderExportExcel(data) {
  return request({
    url: '/refund/exportRefundListToExcel',
    method: 'POST',
    data,
    responseType: 'blob'
  });
}



// WEBPACK FOOTER //
// ./src/api/afterSale.js